import './App.css';
import { Route, BrowserRouter as Router, Routes, Navigate } from 'react-router-dom';
import Login from './components/login';
import React from 'react';
import Registrati from './components/registrati';
import ResetPassword from './components/resetPassword'
import Domanda from "./Domanda";
import Risposta from "./Risposta";
import Button from '@mui/material/Button';
import Tabella from './tabella';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import ListaForm from "./ListaForm";
import ListaFormBackoffice from "./ListaFormBackoffice";
import {configData} from "./configData/configData";
import VisualizzaDownload from "./VisualizzaDownload";
import ListPartner from "./ListPartner";
import ProjectTable from "./ProjectTable";
import SubProjectTable from "./SubProjectTable";
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import AppRoutes from './routes/AppRoutes';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { LanguageProvider } from './i18n/LanguageContext';

// Import per gestire l'avatar dell'utente connesso
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import Divider from '@mui/material/Divider';
import LogoutIcon from '@mui/icons-material/Logout';


//const ruolo = localStorage.getItem("ruolo");
//const token = localStorage.getItem("token");

//const pages = ['Login', 'Registrati', 'Lista dei Candidati', 'Lista dei Form disponibili', 'Lista dei Form', 'Esci', 'Partner', 'Progetti', 'Sotto-Progetti'];
//const link = [configData.SITE_URL+'/login', configData.SITE_URL+'/registrami',configData.SITE_URL+'/tab',configData.SITE_URL+'/listaFormBackOffice', configData.SITE_URL+'/listaFormBackOffice', configData.SITE_URL+'/login']
//const view = [token == null, token == null, token != null && ruolo != null && ruolo != 'ROLE_ADMIN', ruolo == 'ROLE_ADMIN', token != null];


function App() {
  return (
    <Router>
      <LanguageProvider>
        <AuthProvider>
          <div className="app-container" style={{ 
            display: 'flex', 
            flexDirection: 'column',
            minHeight: '100vh'
          }}>
            <Header />
            
            <Box
              component="main"
              sx={{
                flex: '1 0 auto',
                padding: { xs: '12px', sm: '20px' },
              }}
            >
              <AppRoutes />
            </Box>
            
            <Footer />
          </div>
        </AuthProvider>
      </LanguageProvider>
    </Router>
  );
}

function AppContent() {
  const { user, token, ruolo, logout } = useAuth();

  const view = [token == null, token == null, token != null && ruolo != null && ruolo != 'ROLE_ADMIN', ruolo == 'ROLE_ADMIN', token != null];

  function Home() {
    //localStorage.getItem("token") != null ? document.location.href = configData.SITE_URL+"/listaForm" : document.location.href = configData.SITE_URL+"/login";
  
    //localStorage.getItem("token") != null ? document.location.href = configData.SITE_URL+"/homepage" : document.location.href = configData.SITE_URL+"/login";
    //return <HomePage />;
  }


  // State per il menu di navigazione mobile
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  // Funzioni per gestire il menu mobile
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };


  // State per il menu utente
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  // Funzioni per aprire e chiudere il menu utente
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  
  // Funzione per gestire il logout e chiudere il menù
  /*const handleLogout = () => {
    handleCloseUserMenu();
    logout();
    // Usare Navigate di React Router invece di document.location.href
    document.location.href = configData.SITE_URL+"/login";
  };*/

  // Ottieni l'iniziale del nome utente
  /*const getUserInitial = () => {
    if (!user || !user.username) return '?';
    return user.username.charAt(0).toUpperCase();
  };*/


  

  // Da deprecare
  function esci(pagina) {
    if (pagina == "Esci") {
      localStorage.clear();
      logout();
    }
  }


  

}



export default App;